import {basename, extname} from 'path';
import React from 'react';

import {MarvinChemicalFormat} from 'chemistry/marvinjs-wrappers/MarvinJSConstants';
import ChemicalSketcherModal from 'chemistry/molecules/ChemicalSketcherModal';
import {ExternalFile} from 'notebook/util/NoteUtilConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';
import runModal from 'ui-library/runModal';
import * as ImportUtil from 'util/ImportUtil';

import {chemicalStructureFromFile, createChemicalStructureBlob} from './MoleculeUtil';

export interface StructureSketcherToolProps {
  fileType: MarvinChemicalFormat;
  fileName: string;
  externalFile: ExternalFile;
  setNoteLinkedFileFromS3Location: (s3Location: string | undefined) => JQueryPromise<void>;
}

async function handleChemicalEdit(
  fileType: MarvinChemicalFormat,
  fileName: string,
  externalFile: ExternalFile,
  setNoteLinkedFileFromS3Location: (s3Location: string | undefined) => JQueryPromise<void>
): Promise<void> {
  const initialSketcherValue = await chemicalStructureFromFile(externalFile, fileType);
  const sketcherModalOutput = await runModal(ChemicalSketcherModal, {
    initialFilename: basename(fileName, extname(fileName)),
    initialChemicalStructure: initialSketcherValue,
    inputFormat: fileType,
  });
  if (sketcherModalOutput) {
    const chemicalBlob = createChemicalStructureBlob(
      sketcherModalOutput.sketcherValue,
      sketcherModalOutput.filename,
      sketcherModalOutput.saveFormat
    );
    const file = new File([chemicalBlob], chemicalBlob.name!, {
      type: chemicalBlob.type,
    });
    await ImportUtil.upload(file).then((s3location) => setNoteLinkedFileFromS3Location(s3location));
  }
}

export default function StructureSketcherTool({
  fileType,
  fileName,
  externalFile,
  setNoteLinkedFileFromS3Location,
}: StructureSketcherToolProps): JSX.Element {
  return (
    <Tooltip key="structure-sketcher" title="Structure sketcher" delay={300}>
      <a
        className="previewCTA hidden-for-print"
        onClick={() => handleChemicalEdit(fileType, fileName, externalFile, setNoteLinkedFileFromS3Location)}
      >
        <BenchlingIcon icon={FolderItemIcon.SmallMolecule} />
      </a>
    </Tooltip>
  );
}
